export default __webpack_public_path__ + "static/media/WF1.3cb32631.png";